var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-wrap"},[_c('input',{attrs:{"type":"file"},on:{"change":_vm.selectFile}})])])}
var staticRenderFns = []

export { render, staticRenderFns }